.loading {
  text-align: center;

  .message {
    margin-top: 10px;
    font-weight: bold;
  }
}
